
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/accessories/guides",
      function () {
        return require("private-next-pages/accessories/guides.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/accessories/guides"])
      });
    }
  